import { BaseMapper } from '@ps/utils';
import { CompanyBuyerConfigResponseDto } from '../dtos/company-buyer-config.dto';
import {
  BUYER_CONFIG_TOGGLE_KEYS,
  BuyerConfigSettingsForm,
  BuyerConfigToggleKey,
  BuyerConfigToggles,
} from '../../models/company-buyer-config.model';

export class CompanyBuyerConfigMapper extends BaseMapper<
  CompanyBuyerConfigResponseDto,
  BuyerConfigSettingsForm
> {
  public fromDto(dto: CompanyBuyerConfigResponseDto): BuyerConfigSettingsForm {
    return {
      configSettingsId: dto.configSettingsId,
      toggles: this._mapToggles(dto.features),
      defaultCountry: dto.defaultCountry ?? '',
      blockedCountries: dto.blockedCountries ?? [],
      purescoreToken: dto.purescoreToken ?? '',
      exclusionPeriodDefault: dto.exclusionPeriodDefault ?? null,
    };
  }

  // BUYER_CONFIG_TOGGLE_KEYS is a runtime string array, so TypeScript cannot
  // statically prove that folding over it produces every literal key of
  // BuyerConfigToggles. This single assertion is the seeded-default escape
  // hatch called out by docs/object-oriented.md; every key is guaranteed
  // present because BUYER_CONFIG_TOGGLE_KEYS and BuyerConfigToggles share
  // the same source of truth.
  private _mapToggles(features: string[]): BuyerConfigToggles {
    const enabledFeatures = new Set(features ?? []);
    const entries: [BuyerConfigToggleKey, boolean][] =
      BUYER_CONFIG_TOGGLE_KEYS.map((key) => [key, enabledFeatures.has(key)]);
    return Object.fromEntries(entries) as BuyerConfigToggles;
  }
}
